import React from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import AdhocDevicePaymentForm from "../inventory/Devices/Contract/AdhocDevicePaymentForm";

const actions = { closeModal };

const adhocDevicePaymentModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Adhoc Device Payment" onClose={closeModal}>
      <AdhocDevicePaymentForm />
    </Modal>
  );
};

export default connect(null, actions)(adhocDevicePaymentModal);
